import { getJson, postObjectJson } from '../utility/request';
export const getConnectorPartsTech = (merchantId) => getJson(`/parts-tech/config/${merchantId}`);
export const getVehicleByVin = (merchantId, vin) => getJson(`/parts-tech/decode/vin/${merchantId}/${vin}`);
export const getVehicleByPlate = (merchantId, state, tag) => getJson(`/parts-tech/decode/plate/${merchantId}/${state}/${tag}`);
export const getConnectorIntuit = (merchantId) => getJson(`/intuit/config/${merchantId}`);
export const getConnectorDejavoo = (merchantId) => getJson(`/dejavoo/${merchantId}/config`);
export const checkDejavooStatus = (merchantId) => postObjectJson(`/dejavoo/${merchantId}/status`, {});
